import React, {Component} from 'react';
import propTypes from 'prop-types';
import {
    Alert,
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';
import {_withdrawal} from '../../../../../services/apis/AdminAffiliate';

class ModalWithdrawal extends Component {
    state = {
        amount: 0,
        paypal: '',
        success: '',
        error: ''
    }

    componentDidUpdate(prevProp, prevState) {
        if (prevProp.withdrawal.modal !== this.props.withdrawal.modal) {
            const {user} = this.props.withdrawal;

            this.setState({
                amount: user.balance,
                paypal: user.paypal,
                success: '',
                error: ''
            })
        }
    }

    handleChange = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
            success: '',
            error: ''
        })
    }

    transfers = () => {
        const {withdrawal} = this.props;
        const owner = withdrawal.user.hasOwnProperty('owner') ? withdrawal.user.owner : {};
        const ownerId = owner.hasOwnProperty('_id') ? owner._id : '';
        const {amount, paypal} = this.state;
        const total = parseInt(amount, 10);

        _withdrawal(ownerId, total, paypal)
            .then((result) => {
                if (result.success) {
                    this.setState({
                        success: 'Transfer money successfully!'
                    })
                    this.props.toggle();
                    this.props.onReloadPage();
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                })
            });
    }

    render() {
        const {withdrawal} = this.props;
        const owner = withdrawal.user.hasOwnProperty('owner') ? withdrawal.user.owner : {};
        const {amount, paypal, success, error} = this.state;
        const ownerName = owner.hasOwnProperty('name') ? owner.name : '';
        const ownerEmail = owner.hasOwnProperty('email') ? owner.email : '';
        const ownerId = owner.hasOwnProperty('_id') ? owner._id : '';
        return (
            <Modal isOpen={this.props.withdrawal.modal} toggle={this.props.toggle}>
                <ModalHeader toggle={this.props.toggle}>Transfers</ModalHeader>

                <ModalBody>
                    {
                        !!error ? <Alert color="danger">{error}</Alert> : ''
                    }
                    {
                        !!success ? <Alert color="success">{success}</Alert> : ''
                    }
                    <Form>
                        <FormGroup className='row'>
                            <Col sm={2}><h4>Info:</h4></Col>
                            <Col sm={10}>
                                <p>Name: {ownerName}</p>
                                <p>Email: {ownerEmail}</p>
                                <p>Id: {ownerId}</p>
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="transfersAmount" sm={2}>Amount</Label>
                            <Col sm={10}>
                                <Input
                                    type="number"
                                    name="amount"
                                    min={0}
                                    id="transfersAmount"
                                    placeholder="Enter amount..."
                                    value={amount}
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="transfersPaypal" sm={2}>Paypal</Label>
                            <Col sm={10}>
                                <Input
                                    type="email"
                                    name="paypal"
                                    min={0}
                                    id="transfersPaypal"
                                    placeholder="Enter paypal..."
                                    value={paypal}
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </FormGroup>
                    </Form>
                </ModalBody>

                <ModalFooter>
                    <Button color="primary" onClick={this.transfers}>Transfers</Button>{' '}
                    <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

ModalWithdrawal.propTypes = {
    onReloadPage: propTypes.func.isRequired,
    withdrawal: propTypes.object.isRequired,
    toggle: propTypes.func.isRequired
}

export default ModalWithdrawal;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/users/ModalWithdrawal.js